<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>

    <h2 v-if="isTemplate">Create a New Template<br>&nbsp;</h2>
    <h2 v-else-if="route == 'create'">Create a New Resource<br>&nbsp;</h2>
    <h2 v-else-if="existingData.is_template">Update Template</h2>
    <h2 v-else>Update Resource</h2>
    <p v-if="route == 'edit'"><small>Resource ID # {{ existingData.id }}</small><br>&nbsp;</p>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">

          <form id="resourceForm" method="POST" enctype="multipart/form-data" :action="baseUrls.resourceBaseUrl + ((route == 'edit') ? existingData.id + '/' : '')"> <!-- if editing an existing resource, add the resource id to the url -->
            <input type="hidden" name="_token" :value="csrf_token">
            <input v-if="route == 'create'" type="hidden" id="_loadTemplate" name="_loadTemplate" value="0">
            <input v-if="route == 'create'" type="hidden" id="_templateLoaded" name="_templateLoaded" :value="existingData._templateLoaded">
            <input v-if="route == 'templatecreate'" type="hidden" id="_isTemplate" name="_isTemplate" :value="1">
            <input v-if="isTemplate || (existingData && existingData.is_template)" type="hidden" name="template_public" :value="templatePublicValue">
            <input v-if="route == 'edit'" type="hidden" name="id" :value="existingData.id"> <!-- include the Resource id in a hidden input, so that it will be returned if back-end validation fails -->
            <input v-if="route == 'edit'" type="hidden" name="_isTemplate" :value="existingData.is_template"> <!-- include the Resource id in a hidden input, so that it will be returned if back-end validation fails -->
            <input v-if="route == 'edit'" type="hidden" name="_method" value="PUT"> <!-- HTML forms can't make PUT or PATCH requests - add a hidden _method field to spoof these HTTP verbs -->

            <!-- template search / load -->
            <div v-if="route == 'create'" class="container-fluid">
              <div class="row">
                <div class="col-md-8">
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <svg class="bi bi-search" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                      <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                    </svg>
                    <label for="templateFile" class="lead font-weight-bold pl-1" id="templateFileLabel">Use a template to pre-fill the form</label>
                    <input type="text" size="40" @keyup="showSearchResult($event.target.value)" @focus="showSearchResult($event.target.value)" @blur="showSearchResult(false)" placeholder="type your search query here">
                    <div id="livesearch" class="position-absolute bg-white"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- template upload / prefill form  //disabling, no longer used
            <div v-if="route == 'create'" class="container-fluid">
            <div v-if="route == 'create'" class="container-fluid">
              <div class="row">
                <div class="col-md-8">
                </div>
                <div class="col-md-4 border">
                  <div class="form-group">
                    <label for="templateFile" class="lead" id="templateFileLabel">Use a Template to pre-fill the form</label>
                    <input type="file" name="templateFile" class="form-control-file" value="" id="templateFile">
                  </div>
                </div>
              </div>
            </div> -->

            <ul style="width:60%; z-index:auto;" class="alert alert-danger errorMessages" role="alert"></ul>

            <ul class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
              <li v-for="(formCategory, key, index) in this.updatedResourceFramework.categories" class="nav-item">
                <a :class="'nav-link'+(!index ? ' active' : '')+(categoryHasErrors(formCategory.name) ? ' tab-has-errors' : '')" :id="formCategory.name+'-tab'" data-toggle="pill" :href="'#'+formCategory.name" role="tab" :aria-controls="formCategory.name" aria-selected="true" v-html="createTabTitle(formCategory.display_name, index, categoryHasErrors(formCategory.name))"></a>
              </li>
            </ul>

            <p><strong>Fields marked with an asterisk * are required</strong></p>

            <div class="tab-content" id="tabContent">
               <div v-for="(formCategory, key, index) in this.updatedResourceFramework.categories" :class="'tab-pane fade show'+(!index ? ' active' : '')" :id="formCategory.name" role="tabpanel" :aria-labelledby="formCategory.name+'-tab'" v-html="createFormElements(formCategory, index)"></div>
            </div>
          </form>

        </div>
        <div class="col-md-2">
        </div>
      </div>

      <!-- Create or update a resource modal -->
      <div v-if="modalText" class="modal fade" id="updateResourceModal" tabindex="-1" role="dialog" aria-labelledby="updateResourceModalLabel" aria-hidden="true" style="z-index: 10001;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="publishModalLabel">My Responsibilities</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {{modalText.createUpdate}}
              <br>&nbsp;<br>
              <div class="checkbox">
                <label><input type="checkbox" value="" onchange="(!this.checked) ? $('#modal-self-publish-button').addClass('disabled') : $('#modal-self-publish-button').removeClass('disabled');">&nbsp;I have read, understood and agreed to the above.</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <a v-if="route == 'create'" onclick="$('#resourceForm').submit();" class="btn btn-sm btn-success disabled" role="button" id="modal-self-publish-button">Create Resource</a>
              <a v-else onclick="$('#resourceForm').submit();" class="btn btn-sm btn-success disabled" role="button" id="modal-self-publish-button">Update Resource</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Copy resource form to template modal -->
      <div v-if="showCopyAsTemplateFeature" class="modal fade copy-to-template-modal" id="copyToTemplateModal" tabindex="-1" role="dialog" aria-labelledby="copyToTemplateModalLabel" aria-hidden="true" style="z-index: 10001;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header border-0 pb-0">
              <h5 class="modal-title copy-to-template-modal-title" id="copyToTemplateModalLabel">Copy to Template</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body pt-2">
              <p>The fields you have filled out so far will be copied to create a reusable template. You will remain on this page to finish creating your current resource.</p>
              <p>Enter a name for the template in the field below. We recommend that you choose a name distinct from your resource name to avoid confusion later.</p>
              <div class="form-group mb-0">
                <input
                  type="text"
                  class="form-control"
                  id="templateCopyName"
                  v-model="templateCopyName"
                  maxlength="40"
                  :class="{ 'is-invalid': templateCopyNameError }"
                  placeholder="Template name"
                  @keyup.enter.prevent="submitCopyAsTemplate"
                >
                <div v-if="templateCopyNameError" class="invalid-feedback d-block">{{ templateCopyNameError }}</div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-start pt-0">
              <button type="button" class="btn btn-danger resource-form-button" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary ml-2 resource-form-button" :disabled="templateCopyInProgress" @click="submitCopyAsTemplate">{{ templateCopyInProgress ? 'Copying...' : 'Copy' }}</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        baseUrls: Object,
        csrf_token: String,
        resourceFramework: Object,
        errors: Array,
        errorFields: {
          type: [Object, Array],
          default: () => ({})
        },
        existingData: [Object, Array],
        isTemplate: [Boolean, Number],
        modalText: {
          type: [Object, Array, Boolean],
          default: false
        },
        templateLoadedMessage: {
          type: String,
          default: ''
        },
        templateJustLoaded: {
          type: Boolean,
          default: false
        },
      },
      data: function () {
        return {
          map: false,
          mapMarker: false,
          mapPopup: false,
          defaultMapZoom: 15,
          singleActionName: '',
          mapSearchDebounceTimer: false,
          mapSearchLoading: false,
          updatedResourceFramework: this.resourceFramework,
          formData: {
            owner_is_author: '',
            owner_contact_email: '',
          },
          templateCopyName: '',
          templateCopyNameError: '',
          templateCopyInProgress: false,
        }
      },
      computed: {
        showCopyAsTemplateFeature: function () {
          return !this.isTemplate && !(this.existingData && this.existingData.is_template);
        },
        templatePublicValue: function () {
          if (this.existingData && typeof this.existingData.template_public !== 'undefined') {
            return this.existingData.template_public ? 'true' : 'false';
          }
          return 'false';
        },
      },
      created() {
        //if this is a form for creating a template, remove non-template data, and update template specific text(e.g. display names, descriptions)
        if(this.isTemplate || (this.existingData && this.existingData.is_template)) {
          var _this = this;
          $.each(this.updatedResourceFramework.categories, function(key, value) {
            if(!value.template_category) {
              delete _this.updatedResourceFramework.categories[key];
            }
          });
          $.each(this.updatedResourceFramework.fields, function(key, value) {
            if(value.name === 'template_public') {
              delete _this.updatedResourceFramework.fields[key];
              return true;
            }
            if(!value.template_field) {
              delete _this.updatedResourceFramework.fields[key];
            } else {
              _this.updatedResourceFramework.fields[key]['form_display_name'] = _this.updatedResourceFramework.fields[key]['template_form_display_name'];
              _this.updatedResourceFramework.fields[key]['description'] = _this.updatedResourceFramework.fields[key]['template_description'];
            }
          });
        }

        //if this is a form for creating a resource, remove any template-only data
        if(!this.isTemplate && (!this.existingData || !this.existingData.is_template)) {
          var _this = this;
          $.each(this.updatedResourceFramework.categories, function(key, value) {
            if(value.template_only_category) {
              delete _this.updatedResourceFramework.categories[key];
            }
          });
          $.each(this.updatedResourceFramework.fields, function(key, value) {
            if(value.template_only_field) {
              delete _this.updatedResourceFramework.fields[key];
            }
          });
        }

        // Applying a template must not inherit legacy owner_is_author_false from stored templates.
        if (this.route === 'create' && this.existingData && typeof this.existingData === 'object') {
          var loadedFromTemplate = this.templateJustLoaded
            || Number(this.existingData._templateLoaded) > 0
            || this.existingData.owner_is_author_false === 1
            || this.existingData.owner_is_author_false === true
            || this.existingData.owner_is_author === false
            || this.existingData.owner_is_author === 'false';
          if (loadedFromTemplate) {
            this.existingData.owner_is_author = true;
            delete this.existingData.owner_is_author_true;
            delete this.existingData.owner_is_author_false;
            delete this.existingData.owner;
            delete this.existingData.owner_other;
          }
        }

        //converting label names to bold for readability, add asterisk for required fields
        //note: this needs done before "mounted" since the template will already have been rendered at that point
        for (var key in this.updatedResourceFramework.fields) {
          if(this.updatedResourceFramework.fields.hasOwnProperty(key)) {
            this.updatedResourceFramework.fields[key].display_name = '<strong>' + (this.updatedResourceFramework.fields[key].required == '1' ? '* ' : '') + this.updatedResourceFramework.fields[key].form_display_name + '</strong>';
          }
        }
      },
      mounted() {
        this.$nextTick(function () {  //don't run until the entire view has been rendered
          $('form').each(this.createAllErrors);
          if(!this.isTemplate && (!this.existingData || !this.existingData.is_template)) { this.initMap(); }

          //listen for tab changes, correct sizing issues on map due to it being rendered in a tab
          var map = this.$data.map;
          $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
            $('[data-toggle="popover"]').popover('hide');
            if(!this.isTemplate) {
              setTimeout(() => {
                map.invalidateSize();
              }, 300)
            }
          });

          //display validation errors sent from server
          this.showServerErrors();

          //clear field error indicators as the user fixes them
          this.attachErrorClearingHandlers();

          this.initCharacterCounters();

          if (this.showCopyAsTemplateFeature) {
            $(document).on('click', '.copy-as-template-button', (e) => {
              e.preventDefault();
              this.templateCopyName = '';
              this.templateCopyNameError = '';
              $('#copyToTemplateModal').modal('show');
            });
          }

          //disable ENTER key submitting the form
          $('#resourceForm').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
              e.preventDefault();
              return false;
            }
          });

          //listen for template file change and submit
          /*$("#templateFile").change(function() {
            $("#templateFileLabel").html('Uploading Template...');
            $("#_loadTemplate").val('1');
            $("#resourceForm").submit();
          });*/  //disabling, no longer used

          //enable help text popovers
          $('[data-toggle="popover"]').popover();
          $('[data-toggle="popover"]').on('click', function(e) {e.preventDefault(); return true;});

          // Add global function for handling owner_is_author changes
          window.handleOwnerIsAuthorChange = function(value) {
            if (value === 'true') {
              // User is owner - show email field, hide owner selection
              $('.owner_contact_email_group').show();
              $('.owner_group').hide();
            } else {
              // User is volunteer contributor - hide email field, show owner selection  
              $('.owner_contact_email_group').hide();
              $('.owner_group').show();
            }
          };

          // DRP explicit handlers to mimic owner pattern
          window.handleDrpEnabledChange = function(value) {
            // value will be 'true' or 'false' for boolean radios
            if (typeof window.updatePrivacyOptionsUI === 'function') {
              window.updatePrivacyOptionsUI();
            }
          };
          window.handlePrivacyMgmtChange = function(value) {
            if (typeof window.updatePrivacyOptionsUI === 'function') {
              window.updatePrivacyOptionsUI();
            }
          };

          window.syncDataPracticeAiUsageField = function() {
            var v = $('input[name="data_practice_uses_ai"]:checked').val();
            var $wrap = $('#data_practice_ai_usage_group');
            var $input = $('#data_practice_ai_usage');
            if (!$wrap.length || !$input.length) {
              return;
            }
            if (v === 'yes') {
              $wrap.show();
              $input.prop('required', true);
            } else {
              $wrap.hide();
              $input.prop('required', false);
              $input.val('');
            }
          };

          window.handleDataEncryptionChange = function(clickedCheckbox) {
            var exclusiveValues = ['not_encrypted', 'unknown'];
            var $all = $('input[name="data_encryption[]"]');
            var clickedVal = clickedCheckbox.value;

            if (!clickedCheckbox.checked) {
              return;
            }

            if (exclusiveValues.indexOf(clickedVal) !== -1) {
              $all.each(function() {
                if (this !== clickedCheckbox) {
                  $(this).prop('checked', false);
                }
              });
            } else {
              $all.filter(function() {
                return exclusiveValues.indexOf(this.value) !== -1;
              }).prop('checked', false);
            }
          };

          // Initialize the form state based on existing selection
          const _this = this;
          setTimeout(function() {
            var isDraftLikeResource = _this.existingData && (
              typeof _this.existingData.isComplete === 'undefined' || !_this.existingData.isComplete
            );
            var ownerIsAuthorShouldDefaultYes = (
              _this.route === 'create' ||
              _this.route === 'templatecreate' ||
              (_this.route === 'edit' && isDraftLikeResource)
            );
            var ownerIsAuthorValue = $('input[name="owner_is_author"]:checked').val();
            if (!ownerIsAuthorValue && ownerIsAuthorShouldDefaultYes) {
              var $yes = $('input[name="owner_is_author"]').filter(function () {
                var v = this.value;
                return v === 'true' || v === '1' || v === 1 || v === true;
              }).first();
              if ($yes.length) {
                $yes.prop('checked', true);
                ownerIsAuthorValue = $yes.val();
              }
            }
            if (ownerIsAuthorValue) {
              window.handleOwnerIsAuthorChange(ownerIsAuthorValue);
            } else {
              // Default state - hide both additional fields
              $('.owner_contact_email_group').hide();
              $('.owner_group').hide();
            }
            
            // Add direct event listeners as backup
            $('input[name="owner_is_author"]').on('change', function() {
              window.handleOwnerIsAuthorChange(this.value);
            });

            // DRP dynamic UI handlers (config-driven fields)
            window.updatePrivacyOptionsUI = function() {
              // Always re-select groups in case the DOM re-rendered
              var $mgmtGroup = $('.drp_q2_group');
              var $bizGroup = $('.drp_q3_agent');
              var $portalUrlGroups = $('.drp_q3_portal');
              var $emailGroup = $('.drp_q3_email');
              var $pomChoicesWhenDrp = $('.drp_pom_choices_when_drp');

              var drpVal = $('input[name="drp_enabled"]:checked').val();
              var drpOn = (drpVal === '1' || drpVal === 1 || drpVal === true || drpVal === 'true');
              var mgmt = $('input[name="privacy_management_option"]:checked').val();

              function showGroup($g, enable) { if ($g && $g.length) { $g.show(); if (enable) { $g.find('input,select,textarea').prop('disabled', false); } } }
              function hideGroup($g, disable) { if ($g && $g.length) { if (disable) { $g.find('input,select,textarea').prop('disabled', true); } $g.hide(); } }

              if (!drpOn) {
                hideGroup($mgmtGroup, true);
                hideGroup($bizGroup, true);
                hideGroup($portalUrlGroups, true);
                hideGroup($emailGroup, true);
                hideGroup($pomChoicesWhenDrp, true);
                return;
              }

              // DRP is ON: privacy option radios + POM checkboxes (all management paths)
              showGroup($mgmtGroup, true);
              showGroup($pomChoicesWhenDrp, true);
              if (!mgmt) {
                hideGroup($bizGroup, true);
                hideGroup($portalUrlGroups, true);
                hideGroup($emailGroup, true);
              } else if (mgmt === 'agent') {
                showGroup($bizGroup, true);
                hideGroup($portalUrlGroups, true);
                hideGroup($emailGroup, true);
              } else if (mgmt === 'email') {
                hideGroup($bizGroup, true);
                hideGroup($portalUrlGroups, true);
                showGroup($emailGroup, true);
              } else {
                hideGroup($bizGroup, true);
                hideGroup($emailGroup, true);
                showGroup($portalUrlGroups, true);
              }
            };

            $(document).on('change', 'input[name="drp_enabled"]', window.updatePrivacyOptionsUI);
            $(document).on('change', 'input[name="privacy_management_option"]', window.updatePrivacyOptionsUI);
            $(document).on('change', 'input[name="data_practice_uses_ai"]', window.syncDataPracticeAiUsageField);
            $(document).on('change', 'input[name="data_encryption[]"]', function() {
              window.handleDataEncryptionChange(this);
            });

            // Refresh when the Privacy Requests tab is shown
            $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
              var targetId = $(e.target).attr('href'); // e.g., #pom_options
              if (targetId && targetId.indexOf('#pom_options') === 0) {
                window.updatePrivacyOptionsUI();
              }
            });

            // Clear defaults so flow starts with only Q1 visible
            var $drpRadios = $('input[name="drp_enabled"]');
            if (!$drpRadios.is(':checked')) {
              // leave unselected; just update UI with current empty state
            }
            // Do not clear privacy_management_option; preserve existing selection in edit/validation-error flows

            // Run now and again shortly after to cover slow renders
            window.updatePrivacyOptionsUI();
            setTimeout(window.updatePrivacyOptionsUI, 0);
            setTimeout(window.updatePrivacyOptionsUI, 300);

            window.syncDataPracticeAiUsageField();
            setTimeout(window.syncDataPracticeAiUsageField, 0);
            setTimeout(window.syncDataPracticeAiUsageField, 300);
          }, 500);

        })
      },
      methods: {
        createTabTitle: function(name, index, hasErrors) {
          var errorBadge = hasErrors ? ' <span class="tab-error-badge" aria-label="This step has errors" title="This step has errors">!</span>' : '';
          return '<div class="text-center"><p class="mb-0">STEP ' + (index + 1) + '</p><h5>' + name + errorBadge + '</h5></div>';
        },
        hasFieldError: function(fieldName) {
          if (!fieldName) return false;
          var errs = this.errorFields;
          if (!errs) return false;
          // Vue may receive errorFields as Array when empty; treat that as no errors
          if (Array.isArray(errs) && errs.length === 0) return false;
          return Object.prototype.hasOwnProperty.call(errs, fieldName) && errs[fieldName] && errs[fieldName].length > 0;
        },
        getFieldErrorMessages: function(fieldName) {
          if (!this.hasFieldError(fieldName)) return [];
          return this.errorFields[fieldName];
        },
        getFieldErrorMessagesDeduped: function(fieldNames) {
          var seen = {};
          var msgs = [];
          for (var i = 0; i < fieldNames.length; i++) {
            var list = this.getFieldErrorMessages(fieldNames[i]);
            for (var j = 0; j < list.length; j++) {
              if (!seen[list[j]]) {
                seen[list[j]] = true;
                msgs.push(list[j]);
              }
            }
          }
          return msgs;
        },
        escapeHtml: function(str) {
          if (str === undefined || str === null) return '';
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        },
        fieldCharacterCount: function(value) {
          if (value === null || value === undefined) {
            return 0;
          }
          return String(value).length;
        },
        characterCounterText: function(currentLength, maxLength) {
          return currentLength + '/' + maxLength;
        },
        initCharacterCounters: function() {
          var $form = $('#resourceForm');
          if (!$form.length) {
            return;
          }

          var updateCounter = function($el) {
            var maxLength = parseInt($el.attr('maxlength'), 10);
            if (!maxLength || isNaN(maxLength)) {
              return;
            }
            var fieldId = $el.attr('id');
            if (!fieldId) {
              return;
            }
            var $counter = $('#' + fieldId + '-char-counter');
            if (!$counter.length) {
              return;
            }
            $counter.text(($el.val() || '').length + '/' + maxLength);
          };

          $form.find('input[maxlength], textarea[maxlength]').each(function() {
            updateCounter($(this));
          });

          $form.on('input.charCounter', 'input[maxlength], textarea[maxlength]', function() {
            updateCounter($(this));
          });
        },
        fieldErrorMessagesHtml: function(fieldName) {
          if (!this.hasFieldError(fieldName)) return '';
          var msgs = this.getFieldErrorMessages(fieldName);
          var html = '<div class="field-error-feedback" role="alert">';
          for (var i = 0; i < msgs.length; i++) {
            html += '<small class="d-block">' + msgs[i] + '</small>';
          }
          html += '</div>';
          return html;
        },
        // Rendered at the top of a form-group so the user sees the error before the label/input.
        // Also folds in companion "_other" field errors so they aren't orphaned.
        fieldGroupErrorMessagesHtml: function(field) {
          if (!field || !this.fieldHasError(field)) return '';
          var names = [field.name];
          if (field.has_other_field) names.push(field.name + '_other');
          var msgs = this.getFieldErrorMessagesDeduped(names);
          if (!msgs.length) return '';
          var html = '<div class="field-error-feedback field-error-feedback-top" role="alert">';
          for (var i = 0; i < msgs.length; i++) {
            html += '<small class="d-block">' + msgs[i] + '</small>';
          }
          html += '</div>';
          return html;
        },
        fieldHasError: function(field) {
          if (!field) return false;
          if (this.hasFieldError(field.name)) return true;
          // also consider the companion "_other" field used by some radio/checkbox fields
          if (field.has_other_field && this.hasFieldError(field.name + '_other')) return true;
          return false;
        },
        formGroupErrorClass: function(field) {
          return this.fieldHasError(field) ? ' has-error' : '';
        },
        inputErrorClass: function(fieldName) {
          return this.hasFieldError(fieldName) ? ' is-invalid' : '';
        },
        categoryHasErrors: function(categoryName) {
          if (!this.errorFields) return false;
          if (Array.isArray(this.errorFields) && this.errorFields.length === 0) return false;
          for (var key in this.updatedResourceFramework.fields) {
            if (!this.updatedResourceFramework.fields.hasOwnProperty(key)) continue;
            var field = this.updatedResourceFramework.fields[key];
            if (field.form_category_name !== categoryName) continue;
            if (this.fieldHasError(field)) return true;
          }
          return false;
        },
        firstErrorCategoryName: function() {
          var keys = Object.keys(this.updatedResourceFramework.categories);
          for (var i = 0; i < keys.length; i++) {
            var cat = this.updatedResourceFramework.categories[keys[i]];
            if (this.categoryHasErrors(cat.name)) return cat.name;
          }
          return null;
        },
        firstErrorFieldName: function(categoryName) {
          for (var key in this.updatedResourceFramework.fields) {
            if (!this.updatedResourceFramework.fields.hasOwnProperty(key)) continue;
            var field = this.updatedResourceFramework.fields[key];
            if (categoryName && field.form_category_name !== categoryName) continue;
            if (this.fieldHasError(field)) return field.name;
          }
          return null;
        },
        buttonIcon: function(name) {
          var icons = {
            cancel: '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M2.343 2.343a1 1 0 0 1 1.414 0L8 6.586l4.243-4.243a1 1 0 1 1 1.414 1.414L9.414 8l4.243 4.243a1 1 0 1 1-1.414 1.414L8 9.414l-4.243 4.243a1 1 0 1 1-1.414-1.414L6.586 8 2.343 3.757a1 1 0 0 1 0-1.414z"/></svg>',
            previous: '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M10.854 3.646a.5.5 0 0 1 0 .708L7.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0z"/></svg>',
            next: '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M5.146 12.354a.5.5 0 0 1 0-.708L8.793 8 5.146 4.354a.5.5 0 1 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0z"/></svg>',
            save: '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4.5a1 1 0 0 0-.293-.707l-1.5-1.5A1 1 0 0 0 12.5 2H2zm1 1h9v3H3V3zm0 5h10v5H3V8zm2-4h5v2H5V4z"/></svg>',
            check: '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M13.485 1.929a1 1 0 0 1 .586 1.313l-5.5 11a1 1 0 0 1-1.736.11l-3.5-5a1 1 0 1 1 1.636-1.146l2.633 3.761 4.976-9.953a1 1 0 0 1 1.905-.085z"/></svg>'
          };
          return '<span class="resource-form-button-icon' + (name === 'save' ? ' resource-form-button-icon-save' : '') + '">' + (icons[name] || '') + '</span>';
        },
        submitCopyAsTemplate: function() {
          var templateName = (this.templateCopyName || '').trim();
          if (!templateName) {
            this.templateCopyNameError = 'Please enter a name for the template.';
            return;
          }

          this.templateCopyNameError = '';
          this.templateCopyInProgress = true;
          var formData = new FormData(document.getElementById('resourceForm'));
          formData.set('_templateCopyName', templateName);
          // Edit forms include _method=PUT for Laravel method spoofing; strip it so this POST
          // is routed to copy-as-template instead of resource update.
          formData.delete('_method');

          var _this = this;
          $.ajax({
            url: '/resource/copy-as-template',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: { 'X-CSRF-TOKEN': this.csrf_token },
            success: function(response) {
              _this.templateCopyInProgress = false;
              $('#copyToTemplateModal').modal('hide');
              _this.templateCopyName = '';

              var errorList = $('ul.errorMessages', '#resourceForm');
              var successHtml = '<li>' + response.message;
              if (response.templateId) {
                successHtml += ' <a href="/resource/' + response.templateId + '" target="_blank" rel="noopener noreferrer">Click here</a> to view the template in a new tab.';
              }
              successHtml += '</li>';
              errorList.empty().removeClass('alert-danger').addClass('alert-success').show()
                .append(successHtml);

              var offset = errorList.offset();
              if (offset) {
                $('html, body').animate({ scrollTop: Math.max(offset.top - 100, 0) }, 250);
              }
            },
            error: function(xhr) {
              _this.templateCopyInProgress = false;
              if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                var errors = xhr.responseJSON.errors;
                if (errors._templateCopyName && errors._templateCopyName.length) {
                  _this.templateCopyNameError = errors._templateCopyName[0];
                } else {
                  var firstError = null;
                  for (var field in errors) {
                    if (errors.hasOwnProperty(field) && errors[field] && errors[field].length) {
                      firstError = errors[field][0];
                      break;
                    }
                  }
                  _this.templateCopyNameError = firstError || 'Unable to create template. Please check your form data.';
                }
              } else {
                _this.templateCopyNameError = 'An error occurred while creating the template. Please try again.';
              }
            }
          });
        },
        createFormElements: function(formCategory, index) {
          var html = '';
          var buttonLeftHtml = '';
          var buttonRightHtml = '';

          var keys = Object.keys(this.updatedResourceFramework.categories);
          buttonLeftHtml += '<a href="#" onclick="event.preventDefault(); window.history.back();" class="btn btn-danger resource-form-button"><span class="resource-form-button-content">' + this.buttonIcon('cancel') + '<span>Cancel</span></span></a>';

          //genereate a save as draft button(when applicable)
          if(!this.isTemplate) {
            if (typeof this.existingData.isComplete == 'undefined' || !this.existingData.isComplete) {
              if(this.route == 'create') {
                var draftUrl = '/resource/draft/';
              } else {
                var draftUrl = '/resource/' + this.existingData.id + '/draft/';
              }

              var onclickActions = "document.getElementById('resourceForm').action = '" + draftUrl + "';";
              onclickActions += "$('input,textarea,select').removeAttr('required');";
              buttonLeftHtml += '<button type="submit" onclick="' + onclickActions + '" class="btn btn-primary ml-2 resource-form-button"><span class="resource-form-button-content">' + this.buttonIcon('save') + '<span>Save for Later</span></span></button>';
            }

            buttonLeftHtml += '<button type="button" class="btn btn-primary ml-2 resource-form-button copy-as-template-button"><span class="resource-form-button-content">' + this.buttonIcon('save') + '<span>Copy as Template</span></span></button>';
          }

          // add the previous button
          if(index != 0) {
            var elemId = this.updatedResourceFramework.categories[keys[index-1]].name + '-tab';  //id of previous tab
            buttonRightHtml += '<a href="#" onclick="event.preventDefault();$(\'#' + elemId + '\').click();window.scrollTo(0,0);" class="btn btn-primary mr-2 pr-4 resource-form-button" role="button"><span class="resource-form-button-content">' + this.buttonIcon('previous') + '<span>Previous</span></span></a>';
          }

          if(index < keys.length-1) {
            // if this is not the last tab, create a save/continue button that navigates to the next tab
            var elemId = this.updatedResourceFramework.categories[keys[index+1]].name + '-tab';  //id of next tab
            buttonRightHtml += '<a href="#" onclick="event.preventDefault();$(\'#' + elemId + '\').click();window.scrollTo(0,0);" class="btn btn-primary pl-4 resource-form-button" role="button"><span class="resource-form-button-content"><span>Continue</span>' + this.buttonIcon('next') + '</span></a>';
          } else {
            // on the last tab, genereate a create or update button
            var isTemplate = (this.isTemplate || this.existingData && this.existingData.is_template) ? true : false;
            var buttonText = (isTemplate) ? ((this.route == 'templatecreate') ? 'Create Template' : 'Update Template') : ((this.route == 'create') ? 'Create Resource' : 'Update Resource');

            if(isTemplate) {
              buttonRightHtml += '<button type="submit" class="btn btn-success resource-form-button"><span class="resource-form-button-content">' + this.buttonIcon('save') + '<span>' + buttonText + '</span></span></button>';
            } else {
              buttonRightHtml += '<a href="#" role="button" onclick="event.preventDefault();$(\'#updateResourceModal\').modal(\'show\');return false;" class="btn btn-success resource-form-button"><span class="resource-form-button-content">' + this.buttonIcon('check') + '<span>' + buttonText + '</span></span></a>';
            }
          }

          var buttonHtml = '<div class="d-flex justify-content-between align-items-center flex-wrap mb-3">';
          buttonHtml += '<div class="d-flex align-items-center mb-2 mb-md-0">' + buttonLeftHtml + '</div>';
          buttonHtml += '<div class="d-flex align-items-center">' + buttonRightHtml + '</div>';
          buttonHtml += '</div>';

          html += buttonHtml;

          //check if the tab includes a map, add div tag for it
          if(formCategory.has_map) {
              // surface hidden latitude/longitude errors next to the map (visible lat/lng fields don't exist)
              var locationErrorFields = ['latitude', 'longitude'];
              var locationErrorMessages = this.getFieldErrorMessagesDeduped(locationErrorFields);
              if(locationErrorMessages.length) {
                html += '<div class="location-error-banner alert mb-3" role="alert">';
                html += '<strong>Please fix the issue(s) below before continuing:</strong>';
                html += '<ul class="mb-0 mt-1 pl-3">';
                for (var i = 0; i < locationErrorMessages.length; i++) {
                  html += '<li>' + locationErrorMessages[i] + '</li>';
                }
                html += '</ul>';
                html += '</div>';
              }
              html += '<div id="resourcemap" style="height: 400px"></div>';
              html += '<div class="mt-3">';
              html += '<label for="map_address_search" class="font-weight-bold field-label">Find address on map</label>';
              html += '<small class="form-text text-muted field-description">Enter an address and click Find Address to move and zoom the map near that location.</small>';
              html += '<div class="map-address-search-row">';
              html += '<input type="text" class="form-control" id="map_address_search" placeholder="e.g. 5000 Forbes Avenue, Pittsburgh PA">';
              html += '<button class="btn btn-primary mt-0 map-find-address-button" id="map_find_address_button" type="button">Find Address</button>';
              html += '</div>';
              html += '<ul id="map_address_suggestions" class="list-group map-address-suggestions" style="display:none;"></ul>';
              html += '<small id="map_address_search_error" class="form-text text-danger" style="display:none;"></small>';
              html += '</div>';
              html += '<div class="alert alert-primary map-location-help-banner" role="alert"><center><h5>Click anywhere on the map to set or change your resource\'s location.  Adjust its area of coverage using the Radius setting below.</h5><center></div>';
          }
          
          // Wrap existing POM fields so they can be toggled via DRP dynamic handler
          if (formCategory.name === 'pom_options') {
            html += '<div id="pom_portal_fields">';
          }

          //iterate through all form fields
          var _this = this;
          $.each(this.updatedResourceFramework.fields, function(i, field) {
            //if the field belongs to the current category...
            if(field.form_category_name == formCategory.name) {
              
              //check if the element has an existing value or a default value. If neither then define an empty string.
              if(field.name in _this.existingData) {
                var existingValue = _this.existingData[field.name];
                existingValue = (existingValue !== null) ? existingValue : '';
              } else {
                var existingValue = (field.default_value != '') ? field.default_value : '';
              }

              // Stored pom_url includes https://; the input group already shows that prefix.
              if (field.name === 'pom_url' && existingValue) {
                existingValue = String(existingValue).replace(/^https?:\/\//i, '');
              }

              //if applicable, surface this field's server error messages above its heading/label
              html += _this.fieldGroupErrorMessagesHtml(field);

              //if applicable, create a form_heading
              html += _this.createHeading(field);

              //build the element based on what type of field it is
              switch(field.element_type) {
                case 'text':
                  html += _this.createTextElement(field, existingValue);
                  break;
                case 'textarea':
                  html += _this.createTextAreaElement(field, existingValue);
                  break;
                case 'email':
                  html += _this.createEmailElement(field, existingValue);
                  break;
                case 'url':
                  html += _this.createUrlElement(field, existingValue);
                  break;
                case 'number':
                  html += _this.createNumberElement(field, existingValue);
                  break;
                case 'file':
                  html += _this.createFileElement(field);
                  break;
                case 'select':
                  html += _this.createSelectElement(field, existingValue);
                  break;
                case 'checkbox':
                  html += _this.createCheckboxElement(field, existingValue);
                  break;
                case 'single_checkbox':
                  html += _this.createSingleCheckboxElement(field, existingValue);
                  break;
                case 'radio':
                  html += _this.createRadioElement(field, existingValue);
                  break;
                case 'hidden':
                  html += _this.createHiddenElement(field, existingValue);
                  break;
                default:
                  //
              }
            }
          });

          //add buttons again at the bottom
          html += buttonHtml;

          // Close POM wrapper if applicable
          if (formCategory.name === 'pom_options') {
            html += '</div>'; // end #pom_portal_fields
          }

          return html;
        },
        initMap: function() {
          //init the map
          this.$data.map = window.L.map('resourcemap').setView([39.8, -98.6], 4); //default to United States view
          this.bindMapAddressSearchHandlers();

          window.L.control.scale().addTo(this.map);

          //init some map components
          this.$data.mapMarker = L.marker([39.8, -98.6]);
          this.$data.mapPopup = L.popup();
      		this.$data.mapCircle = L.circle([39.8, -98.6], {
      			color: 'orange',
      			fillColor: '#ffa200',
      			fillOpacity: 0.35,
      			radius: $('#radius').val()
      		});

          //add the content
          //L.tileLayer('/map/tile/{s}/{id}/{z}/{x}/{y}', {  //for use when proxying the tile requests

          /* DEPRECATED L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank">CC-BY-SA</a>',
      			maxZoom: 18,
            minZoom: 3,
      			id: 'mapbox.streets',
      			accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
      		}).addTo(this.$data.map); */

          L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
            tileSize: 512,
            maxZoom: 18,
            minZoom: 3,
            zoomOffset: -1,
            id: 'jdonnell/ckg9vp1o403lx1as8i81og3ir',
            accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
          }).addTo(this.$data.map);

          /* check if existing data has valid LatLng set */
          var validLatLng = true;
          //latitude check
          if('latitude' in this.existingData) {  //check that value exists
            if(!(this.existingData.latitude <= 90 && this.existingData.latitude >= -90)) {  //check valid range
              validLatLng = false;
            }
          } else { validLatLng = false; }
          //longitude check
          if('longitude' in this.existingData) {  //check that value exists
            if(!(this.existingData.longitude <= 180 && this.existingData.longitude >= -180)) {  //check valid range
              validLatLng = false;
            }
          } else { validLatLng = false; }

          //if valid LatLng, move the map to that location and place a marker
          if(validLatLng) {
            this.$data.map.setView([this.existingData.latitude, this.existingData.longitude], this.$data.defaultMapZoom);
            var fakeEvent = {latlng: {lat: this.existingData.latitude, lng: this.existingData.longitude}};
            this.handleMapClick(fakeEvent);
          }
          //else attempt to get LatLng based on ip address, then move map to that location
          else {
            //attempt to get LatLng based on ip address, then move map to that location
            var self = this;
            //geolocation via browser
            if(navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(self.setMapLatLng);
            } else { //Geolocation is not supported by this browser
              this.$data.mapPopup
                .setLatLng([$('#latitude').val(), $('#longitude').val()])
                .setContent('<p>Geolocation is not supported by this browser</p>')
                .openOn(this.$data.map);
            }
          }

          //handle map clicks
          this.$data.map.on('click', this.handleMapClick);

          //add onChange function to radius form element
          $('#radius').change(this.handleRadiusChange);
        },
        bindMapAddressSearchHandlers: function() {
          var _this = this;

          $('#resourceForm').off('input.mapAddressSearch', '#map_address_search').on('input.mapAddressSearch', '#map_address_search', function() {
            _this.handleAddressInput($(this).val());
          });

          $('#resourceForm').off('keydown.mapAddressSearch', '#map_address_search').on('keydown.mapAddressSearch', '#map_address_search', function(event) {
            if(event.keyCode === 13) {
              event.preventDefault();
              _this.handleAddressSearch();
            }
          });

          $('#resourceForm').off('click.mapAddressSearch', '#map_find_address_button').on('click.mapAddressSearch', '#map_find_address_button', function(event) {
            event.preventDefault();
              event.stopPropagation();
            _this.handleAddressSearch();
          });

          $('#resourceForm').off('mousedown.mapAddressSearch', '#map_address_suggestions li').on('mousedown.mapAddressSearch', '#map_address_suggestions li', function(event) {
            event.preventDefault();
              event.stopPropagation();
            var lat = parseFloat($(this).attr('data-lat'));
            var lng = parseFloat($(this).attr('data-lng'));
            var label = $(this).text();

            if(!isNaN(lat) && !isNaN(lng)) {
              $('#map_address_search').val(label);
              _this.hideAddressSuggestions();
              _this.moveMapToCoordinates(lat, lng);
            }
          });
        },
        setAddressSearchLoading: function(isLoading) {
          this.mapSearchLoading = isLoading;
          $('#map_find_address_button').prop('disabled', isLoading).text(isLoading ? 'Searching...' : 'Find Address');
        },
        setAddressSearchError: function(message) {
          if(message) {
            $('#map_address_search_error').text(message).show();
          } else {
            $('#map_address_search_error').text('').hide();
          }
        },
        renderAddressSuggestions: function(suggestions) {
          var suggestionList = $('#map_address_suggestions');
          suggestionList.empty();

          if(!Array.isArray(suggestions) || !suggestions.length) {
            suggestionList.hide();
            return;
          }

          for(var i = 0; i < suggestions.length; i++) {
            suggestionList.append('<li class="list-group-item list-group-item-action" data-lat="' + suggestions[i].lat + '" data-lng="' + suggestions[i].lng + '">' + suggestions[i].label + '</li>');
          }

          suggestionList.show();
        },
        hideAddressSuggestions: function() {
          $('#map_address_suggestions').empty().hide();
        },
        fetchAddressSuggestions: async function(query, limit) {
          if(!query) {
            return [];
          }

          try {
            var encodedAddress = encodeURIComponent(query);
            var response = await fetch('https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=' + limit + '&q=' + encodedAddress, {
              headers: {
                'Accept': 'application/json'
              }
            });

            if(!response.ok) {
              return [];
            }

            var geocodeResults = await response.json();
            if(!Array.isArray(geocodeResults)) {
              return [];
            }

            return geocodeResults.map(function(result) {
              return {
                label: result.display_name,
                lat: parseFloat(result.lat),
                lng: parseFloat(result.lon),
              };
            }).filter(function(result) {
              return !isNaN(result.lat) && !isNaN(result.lng);
            });
          } catch (error) {
            return [];
          }
        },
        moveMapToCoordinates: function(lat, lng) {
          this.$data.map.setView([lat, lng], Math.max(this.$data.defaultMapZoom, 16));
          this.handleMapClick({latlng: {lat: lat, lng: lng}});
        },
        handleAddressInput: function(query) {
          var _this = this;
          this.setAddressSearchError('');

          if(this.mapSearchDebounceTimer) {
            clearTimeout(this.mapSearchDebounceTimer);
          }

          var trimmedQuery = (query || '').trim();
          if(trimmedQuery.length < 3) {
            this.hideAddressSuggestions();
            return;
          }

          this.mapSearchDebounceTimer = setTimeout(async function() {
            var suggestions = await _this.fetchAddressSuggestions(trimmedQuery, 5);
            _this.renderAddressSuggestions(suggestions);
          }, 300);
        },
        handleAddressSearch: async function() {
          var query = ($('#map_address_search').val() || '').trim();
          this.setAddressSearchError('');
          this.hideAddressSuggestions();

          if(!query) {
            this.setAddressSearchError('Please enter an address to search.');
            return;
          }

          this.setAddressSearchLoading(true);

          try {
            var geocodeResults = await this.fetchAddressSuggestions(query, 5);

            if(!Array.isArray(geocodeResults) || !geocodeResults.length) {
              this.setAddressSearchError('Address not found. Please try a more specific address.');
              return;
            }

            this.renderAddressSuggestions(geocodeResults);
            this.moveMapToCoordinates(geocodeResults[0].lat, geocodeResults[0].lng);
          } catch (error) {
            this.setAddressSearchError('Unable to search for that address right now. Please try again.');
          } finally {
            this.setAddressSearchLoading(false);
          }
        },
        addHelpTextPopover: function(field, isDataField) {
          //if applicable add a help text icon/popover
          if(field.help_text) {
            return '&nbsp;&nbsp;<a href="#" data-toggle="popover" data-trigger="focus" data-content="' + field.help_text + '"><i class="fa fa-question-circle text-primary"></i></a>';
          }
          return '';
        },
        addDescriptionText: function(field, isDataField) {
          if(field.description) {
            return '<small class="form-text text-muted field-description">' + field.description + '</small>';
          }
          return '';
        },
        handleMapClick: function(e) {
          /* fix for leaflet
           * leaflet allows the map to scroll left/right indefinitely, resulting in longitiude values that are outside the -180 to 180 range
           * if a user clicks in one of these areas, the longitude is adjusted accordingly
           */
          while(e.latlng.lng > 180) {
            e.latlng.lng -= 360;
          }
          while(e.latlng.lng < -180) {
            e.latlng.lng += 360;
          }

          this.$data.map.setView([e.latlng.lat,e.latlng.lng]);  //center the map on the location clicked
          this.$data.mapMarker.setLatLng(e.latlng).addTo(this.$data.map);  //place a marker
          this.$data.mapCircle.setLatLng(e.latlng).setRadius($('#radius').val()).addTo(this.$data.map); //place the area of coverage circle
          $('#latitude').val(e.latlng.lat);  //set hidden latitude form field
          $('#longitude').val(e.latlng.lng);  //set hidden longitude form field
          this.clearLocationErrorBanner();  //user supplied a location, so clear any lat/lng error banner
        },
        handleRadiusChange: function() {
          this.$data.mapCircle.setRadius($('#radius').val())
        },
        setMapLatLng: function(position) {
          if (typeof position.coords.latitude !== 'undefined' && typeof position.coords.longitude !== 'undefined') {
            this.$data.map.setView([position.coords.latitude, position.coords.longitude], this.$data.defaultMapZoom);
          }
        },
        createHeading: function(field) {
          var html ='';

          if(field.heading !== false) {
            html += '<h3>&nbsp;<br>' + field.heading + '</h3>';
          }
          return html;
        },
        createTextElement: function(field, existingValue) {
          // Add stable group classes for DRP dynamic UI when applicable
          var extraGroupClass = '';
          if (field.name === 'business_id') { extraGroupClass += ' drp_q3_agent'; }
          if (field.name === 'pom_url' || field.name === 'pom_endpoint_status') { extraGroupClass += ' drp_q3_portal'; }
          // Hide by default for DRP-dependent groups
          var extraStyle = '';
          if (extraGroupClass.indexOf('drp_q3_agent') !== -1 || extraGroupClass.indexOf('drp_q3_portal') !== -1) {
            extraStyle = ' style="display:none;"';
          }
          if (field.name === 'data_practice_ai_usage') {
            extraStyle = ' id="data_practice_ai_usage_group" style="display:none;"';
          }

          var html = '<div class="form-group' + extraGroupClass + this.formGroupErrorClass(field) + '"' + extraStyle + '>';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '')  + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<div class="input-group">'

          //initialize as blank, updated later if applicable
          var ariaDescribedby = '';
          var onKeyupHTML = '';

          //should this element update other elements on the form when changed
          if(field.updateEvent === true) {
            var onkeyupFunc = "$('." + field.name + "_update').html('https://' + $('#" + field.name + "').val() + '/' );";
            onKeyupHTML = 'onkeyup="' + onkeyupFunc + '"';
          }

          if(field.prepend !== false) {
            var additionalClass = (field.inputGroupPopulateFrom !== false) ? field.inputGroupPopulateFrom + '_update' : '';
            html += '<div class="input-group-prepend">';
            html += '<span class="input-group-text ' + additionalClass + '" id="' + field.name + '_addon">' + field.prepend + '</span>';
            html += '</div>';
            ariaDescribedby = 'aria-describedby="' + field.name + '_addon"';
          }

          var maxLength = field.max_length ? parseInt(field.max_length, 10) : 0;
          var charCount = this.fieldCharacterCount(existingValue);
          html += '<input type="text" name="' + field.name + '" class="form-control' + this.inputErrorClass(field.name) + '" id="' + field.name + '" ' + 'value="' + existingValue + '"' + ' placeholder=""' + (field.required && field.name !== 'data_practice_ai_usage' ? ' required' : '') + (maxLength > 0 ? ' maxlength="' + maxLength + '"' : '') + ' ' + onKeyupHTML + ' ' + ariaDescribedby + '>';
          if (maxLength > 0) {
            html += '<div class="input-group-append">';
            html += '<span class="input-group-text char-counter" id="' + field.name + '-char-counter" aria-live="polite">' + this.characterCounterText(charCount, maxLength) + '</span>';
            html += '</div>';
          }
          html += '</div>';
          html += '</div>';
          return html;
        },
        createOtherTextElement: function(parentName, elementType, placeholderText = false) {
          var name = parentName + '_other';
          var existingValue = this.existingData[name];
          existingValue = (existingValue !== null && existingValue !== undefined) ? existingValue : '';
          var placeholder = (placeholderText) ? placeholderText : 'please specify';
          var otherMaxLength = this.updatedResourceFramework.other_field_max_length || 40;
          var checkBoxOnClickCode = "if(this.checked){$('#" + name + "').prop('disabled', false);}else{$('#" + name + "').prop('disabled', true); $('#" + name + "').val('');} $('#" + name + "').trigger('input');";
          var checkedText = (existingValue) ? 'checked' : '';
          var disabledText = (existingValue) ? '' : 'disabled';
          var html = '<div class="form-check d-flex flex-wrap align-items-center">';
          html += '<input class="form-check-input" type="checkbox" value="" id="'+ name + '_check" onclick="' + checkBoxOnClickCode + '" ' + checkedText + '>';

          if(elementType == 'radio') {
            html += '<label class="field-check-label" for="' + name + '">Additional comments</label>';
          } else {
            html += '<label class="field-check-label" for="' + name + '">Other</label>';
          }

          var otherCharCount = this.fieldCharacterCount(existingValue);
          html += '<input type="text" name="' + name + '" class="form-control ml-3 col-sm-5' + this.inputErrorClass(name) + '" id="' + name + '" value="' + existingValue + '" placeholder="(max ' + otherMaxLength + ' chars)" maxlength="' + otherMaxLength + '" ' + disabledText + '>';
          html += '<span class="char-counter text-muted small ml-2 align-self-center" id="' + name + '-char-counter" aria-live="polite">' + this.characterCounterText(otherCharCount, otherMaxLength) + '</span>';
          html += '</div>';
          return html;
        },
        createTextAreaElement: function(field, existingValue) {
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          var textareaMaxLength = field.max_length ? parseInt(field.max_length, 10) : 0;
          var textareaCharCount = this.fieldCharacterCount(existingValue);
          html += '<textarea name="' + field.name + '" class="form-control' + this.inputErrorClass(field.name) + '" id="' + field.name + '" ' + ' rows="3"' + (field.required ? ' required' : '') + (textareaMaxLength > 0 ? ' maxlength="' + textareaMaxLength + '"' : '') + '>' + existingValue + '</textarea>';
          if (textareaMaxLength > 0) {
            html += '<div class="d-flex justify-content-end"><small class="char-counter text-muted" id="' + field.name + '-char-counter" aria-live="polite">' + this.characterCounterText(textareaCharCount, textareaMaxLength) + '</small></div>';
          }
          html += '</div>';
          return html;
        },
        createEmailElement: function(field, existingValue) {
          var additionalClass = (field.name === 'owner_contact_email') ? ' owner_contact_email_group' : '';
          if (field.name === 'pom_email') { additionalClass += ' drp_q3_email'; }
          var extraStyle = (field.name === 'pom_email') ? ' style="display:none;"' : '';
          var html = '<div class="form-group' + additionalClass + this.formGroupErrorClass(field) + '"' + extraStyle + '>';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<input type="email" name="' + field.name + '" class="form-control' + this.inputErrorClass(field.name) + '" id="' + field.name + '" ' + 'value="' + existingValue + '"' + ' placeholder=""' + (field.required ? ' required' : '') + '>';
          html += '</div>';
          return html;
        },
        createUrlElement: function(field, existingValue) {
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<input type="url" name="' + field.name + '" class="form-control' + this.inputErrorClass(field.name) + '" id="' + field.name + '" ' + 'value="' + existingValue + '"' + ' placeholder=""' + (field.required ? ' required' : '') + '>';
          html += '</div>';
          return html;
        },
        createNumberElement: function(field, existingValue) {
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<input type="number" name="' + field.name + '" class="form-control' + this.inputErrorClass(field.name) + '" id="' + field.name + '" ' + 'value="' + existingValue + '"' + ' min="0" placeholder=""' + (field.required ? ' required' : '') + '>';
          html += '</div>';
          return html;
        },
        createFileElement: function(field) {
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<input type="file" name="' + field.name + '" accept="image/jpeg,image/png,image/gif,image/webp" class="form-control-file' + this.inputErrorClass(field.name) + '" id="' + field.name + '"' + (field.required ? ' required' : '') + '>';
          html += '</div>';
          return html;
        },
        createSelectElement: function(field, existingValue) {
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';
          html += '<select class="custom-select' + this.inputErrorClass(field.name) + '" name="' + field.name + '">';

          //iterate through the form data values...
          $.each(this.updatedResourceFramework.data, function(i, data) {
            //find the Data values that correspond to the current Form Field
            if(data.form_field_name == field.name) {
              var dataValue = (!field.boolean_value ? data.value : (data.value == 1 ? 'Yes' : 'No'));  //for boolean values convert to Yes/No
              //if existing data for this field was sent from the server and it matches this, set it as the active selection
              html += '<option value="' + data.value + '"' + ((existingValue == dataValue || existingValue == data.value) ? ' selected' : '') + '>' + data.display_value + '</option>';
            }
          });
          html += '</select>';
          html += '</div>';
          return html;
        },
        createRadioElement: function(field, existingValue) {
          var additionalClass = (field.name === 'owner') ? ' owner_group' : '';
          // Add stable group classes for DRP dynamic UI when applicable
          if (field.name === 'drp_enabled') { additionalClass += ' drp_q1_group'; }
          if (field.name === 'privacy_management_option') { additionalClass += ' drp_q2_group'; }
          // Hide Q2 and owner_is_author by default (owner handled programmatically)
          var extraStyle = '';
          if (field.name === 'privacy_management_option') { extraStyle = ' style="display:none;"'; }
          if (field.name === 'owner_is_author') { extraStyle = ' style="display:none;"'; }
          var html = '<div class="form-group' + additionalClass + this.formGroupErrorClass(field) + '"' + extraStyle + '>';
          html += '<label class="field-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';

          //iterate through the form data values...
          var _this = this;
          $.each(this.updatedResourceFramework.data, function(i, data) {
            //find the Data values that correspond to the current Form Field
            if(data.form_field_name == field.name) {

              //if existing data for this field was sent from the server and it matches this, set it as the active selection
              var restoreSelection = (_this.route != 'create' || _this.errors.length > 0 || _this.templateJustLoaded);
              var checked = (existingValue !== '' && existingValue == data.value && restoreSelection) ? ' checked="checked"' : '';

              // owner_is_author is hidden on create/draft flows and must stay "Yes" so conditional fields stay visible (resources and templates).
              var isDraftLikeResource = _this.existingData && (
                typeof _this.existingData.isComplete === 'undefined' || !_this.existingData.isComplete
              );
              var forceOwnerIsAuthorYes = field.name === 'owner_is_author' && (
                _this.route === 'create' ||
                _this.route === 'templatecreate' ||
                (_this.route === 'edit' && isDraftLikeResource)
              );
              if (forceOwnerIsAuthorYes) {
                checked = (data.value === true || data.value === 'true' || data.value == 1 || data.value == '1')
                  ? ' checked="checked"'
                  : '';
              }

              //if this is a required selection
              var required = (field.required) ? 'required=""' : '';

              // Add dynamic behavior for owner_is_author field
              var onChange = '';
              if(field.name === 'owner_is_author' && field.updateEvent === true) {
                onChange = ' onchange="handleOwnerIsAuthorChange(this.value)"';
              }
              if(field.name === 'drp_enabled' && field.updateEvent === true) {
                onChange = ' onchange="handleDrpEnabledChange(this.value)"';
              }
              if(field.name === 'privacy_management_option' && field.updateEvent === true) {
                onChange = ' onchange="handlePrivacyMgmtChange(this.value)"';
              }
              if(field.name === 'data_practice_uses_ai' && field.updateEvent === true) {
                onChange = ' onchange="window.syncDataPracticeAiUsageField()"';
              }

              html += '<div class="form-check">';
              html += '<input class="form-check-input" type="radio" name="' + field.name + '" value="'+ data.value +'" id="' + field.name + '_' + data.value + '"' + required + ' ' + checked + onChange + '>';
              html += '<label class="form-check-label" for="' + field.name + '_' + data.value + '">' + data.display_value + '</label>';
              html += _this.addHelpTextPopover(data, true);
              html += _this.addDescriptionText(data, true);
              html += '</div>';
            }
          });

          //create text box for "other"
          if(field.has_other_field) {
            html += this.createOtherTextElement(field.name, field.element_type, field.other_field_placeholder_text);
          }

          html += '</div>';
          return html;
        },
        createCheckboxElement: function(field, existingValue) {
          var additionalClass = (field.name === 'owner') ? ' owner_group' : '';
          if (field.name === 'pom_choices') { additionalClass += ' drp_pom_choices_when_drp'; }
          // Hidden until DRP "Yes" (not tied to portal-only URL fields)
          var extraStyle = '';
          if (field.name === 'pom_choices') { extraStyle = ' style="display:none;"'; }
          var html = '<div class="form-group' + additionalClass + this.formGroupErrorClass(field) + '"' + extraStyle + '>';
          html += '<label class="field-label" >' + ((field.required) ? '*' : '') + field.form_display_name + '</label>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '<br>';

          //iterate through the form data values...
          var _this = this;
          $.each(this.updatedResourceFramework.data, function(i, data) {
            //find the Data values that correspond to the current Form Field
            if(data.form_field_name == field.name) {
              //check existing data to determine if this box should be checked
              var checked = '';
              if($.isArray(existingValue)) {
                for(var i=0; i<existingValue.length; i++) {
                  if(existingValue[i] == data.value) {
                    //console.log('array ' + existingValue[i] + ' ' + data.value);
                      checked = ' checked="checked"';
                  }
                }
              } else if(existingValue == data.value) {
                //console.log('single ' + existingValue + ' ' + data.value);
                checked = ' checked="checked"';
              }

                html += '<div class="form-check">';
                html += '<input class="form-check-input" type="checkbox" name="' + field.name + '[]" value="' + data.value + '" id="' +data.value + '"' + checked + '>';
                html += '<label class="form-check-label" for="' + data.value + '">' + data.display_value + '</label>';
                html += _this.addHelpTextPopover(data, true);
                html += _this.addDescriptionText(data, true);
                html += '</div>';
            }
          }); //end foreach

          //create text box for "other"
          if(field.has_other_field) {
            html += this.createOtherTextElement(field.name, field.element_type, field.other_field_placeholder_text);
          }

          html += '</div>';
          return html;
        },
        createSingleCheckboxElement: function(field, existingValue) {
          var labelText = field.checkbox_label || field.form_display_name;
          var checked = (existingValue === true || existingValue === 1 || existingValue === '1' || existingValue === 'on') ? ' checked="checked"' : '';
          var requiredAttr = (field.required && field.name !== 'data_practice_ai_usage') ? ' required' : '';
          var html = '<div class="form-group' + this.formGroupErrorClass(field) + '">';
          html += '<div class="form-check">';
          html += '<input class="form-check-input" type="checkbox" name="' + field.name + '" id="' + field.name + '" value="1"' + requiredAttr + checked + '>';
          html += '<label class="form-check-label" for="' + field.name + '">' + ((field.required) ? '*' : '') + labelText + '</label>';
          html += '</div>';
          html += this.addHelpTextPopover(field, false);
          html += this.addDescriptionText(field, false);
          html += '</div>';
          return html;
        },
        createHiddenElement: function(field, existingValue) {
          return '<input type="hidden" id="' + field.name + '" name="' + field.name + '" value="' + existingValue + '">';
        },
        showServerErrors: function() {
          var form = $('form');
          var errorList = $('ul.errorMessages', form);
          errorList.empty().hide().removeClass('alert-danger alert-success');

          if (this.templateLoadedMessage) {
            errorList.addClass('alert-success').show().append('<li>' + this.templateLoadedMessage + '</li>');
            return;
          }

          // Auto-switch to the tab containing the first errored field, then scroll to it
          var firstErrCategory = this.firstErrorCategoryName();
          if (firstErrCategory) {
            var tabSelector = '#' + firstErrCategory + '-tab';
            var $tab = $(tabSelector);
            if ($tab.length) {
              $tab.click();
            }

            var firstErrField = this.firstErrorFieldName(firstErrCategory);
            // hidden lat/lng errors have no visible form field; scroll to the location banner instead
            var hiddenLocationField = (firstErrField === 'latitude' || firstErrField === 'longitude');
            var $target;
            if (hiddenLocationField) {
              $target = $('.location-error-banner').first();
            } else if (firstErrField) {
              $target = $('#' + firstErrField + ', [name="' + firstErrField + '"], [name="' + firstErrField + '[]"]').first();
              if (!$target.length) {
                $target = $('.has-error').first();
              } else {
                $target = $target.closest('.form-group');
              }
            }

            if ($target && $target.length) {
              // allow the tab transition to complete first
              setTimeout(function() {
                var offset = $target.offset();
                if (offset) {
                  $('html, body').animate({ scrollTop: Math.max(offset.top - 100, 0) }, 250);
                }
              }, 200);
            }
          }
        },
        attachErrorClearingHandlers: function() {
          var _this = this;
          // when the user edits any input inside an errored form-group, clear that group's error indicators
          $('#resourceForm').off('input.clearFieldError change.clearFieldError')
            .on('input.clearFieldError change.clearFieldError', 'input, textarea, select', function() {
              var $group = $(this).closest('.form-group');
              if ($group.length && $group.hasClass('has-error')) {
                _this.clearFormGroupError($group);
              }
            });
        },
        clearFormGroupError: function($group) {
          $group.removeClass('has-error');
          $group.find('.is-invalid').removeClass('is-invalid');
          $group.find('.field-error-feedback').remove();
          // the top-positioned feedback sits before the form-group, possibly above an h3 heading
          var $sib = $group.prev();
          while ($sib.length) {
            if ($sib.hasClass('field-error-feedback-top')) {
              $sib.remove();
              break;
            }
            if (!$sib.is('h3')) break;
            $sib = $sib.prev();
          }
          this.updateTabErrorIndicator($group.closest('.tab-pane'));
        },
        clearLocationErrorBanner: function() {
          var $banner = $('.location-error-banner');
          if (!$banner.length) return;
          var $tabPane = $banner.closest('.tab-pane');
          $banner.remove();
          this.updateTabErrorIndicator($tabPane);
        },
        updateTabErrorIndicator: function($tabPane) {
          if (!$tabPane || !$tabPane.length) return;
          var tabId = $tabPane.attr('id');
          if (!tabId) return;
          var stillHasErrors = $tabPane.find('.has-error, .location-error-banner').length > 0;
          if (stillHasErrors) return;
          var $tab = $('#' + tabId + '-tab');
          $tab.removeClass('tab-has-errors');
          $tab.find('.tab-error-badge').remove();
        },
        createAllErrors: function() {
          var form = $('form');
          $('input[type=submit], button[type=submit]', form).on('click', this.showAllErrorMessages);
          $('input[type=text]', form).on('keypress', function(event) {
            if(this.id == 'map_address_search') {
              return;
            }
            //keyCode 13 = Enter
            if (event.keyCode == 13) {
              this.showAllErrorMessages();
            }
          });
        },
        showAllErrorMessages: function() {
            var form = $('form');
            var errorList = $('ul.errorMessages', form);
            errorList.empty().hide();

            //Find all invalid fields within the form.
            var firstErrorTabSelected = false; //the tab containing the field with the first error should be automatically selected
            form.find(':invalid').each(function(index, node) {
              //check if the tab with the first error has been selected yet
              if(!firstErrorTabSelected) {
                var tabId = $(node).parent().parent()[0].id + '-tab';  //get the tab id
                $('#' + tabId).click();  //call it's click method
                firstErrorTabSelected = true;
              }

            });
          },
          showSearchResult: function(str) {
            /* cleanup any remaining tooltips from previous searches */
            $('[data-toggle="tooltip"]').tooltip('hide'); //hide any currently displayed tooltips
            $('.tooltip-inner').remove(); //remove any orphaned tooltips
            $('.arrow').remove(); //remove any orphaned tooltip arrows

            // **Temporarily disabled** - currently displaying list of templates when blank query exists - refer to back-end code comments for full details
            // if no search string, remove the search results div's border
            if(str.length==0) {
              //$("#livesearch").html('');
              //$("#livesearch").removeClass('border');
            //  return;
            }

            //if the search box loses focus, remove the search results div's border
            if(str === false) {
              //make the change after a brief pause to allow clicks on template names to register
              setTimeout(() => {
                $("#livesearch").html('');
                $("#livesearch").removeClass('border');
              }, 250);
              return;
            }

            $("#livesearch").html('<h6 class="ml-2 mr-2 mt-2 text-muted">SEARCHING...</h6>');
            var xmlhttp=new XMLHttpRequest();
            xmlhttp.onreadystatechange=function() {
              if (this.readyState==4 && this.status==200) {
                var response = JSON.parse(this.responseText);
                if(!response.results.length) {
                  var html = '<h6 class="ml-2 mr-2 mt-2 text-muted">NO RESULTS</h6>';
                } else {
                  var html = '';
                  for(var i=0; i<response.results.length; i++) {
                    if(response.results[i].isOwner) {  //add owner icon
                      html += '<svg class="bi bi-person-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>';
                    } else { //add circle icon
                      html += '<svg class="bi bi-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8"/></svg>';
                    }
                    html += '<a class="ml-2 mr-2" data-toggle="tooltip" data-placement="right" title="' + response.results[i].description + '" href="' + response.results[i].url + '">' + response.results[i].name + '</a><br />';
                  }
                }
                $("#livesearch").html(html);
                $("#livesearch").addClass('border');
                $('[data-toggle="tooltip"]').tooltip();
              }
            }
            xmlhttp.open("GET", "/template/search/" + encodeURIComponent(str), true);
            xmlhttp.send();
          },
      } //close methods
    } //close export
</script>
<style>
  .errorMessages {
      display: none;
      list-style-type: none;
  }
  .errorMessages span {
      font-weight: bold;
  }
  .prev-button {
    margin-right: 10px;
  }
  .btn {
    margin-top: 25px;
  }
  .info-icon-small {
      font-size: small;
  }
  .info-icon-medium {
      font-size: medium;
  }
  .field-label {
    font-size: large;
  }
  .field-description {
    margin-top: 0px;
    padding-top: 0px;
  }
  .resource-form-button {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    line-height: 1;
    min-height: 44px;
  }
  .resource-form-button-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    line-height: 1;
  }
  .resource-form-button-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.2em;
    height: 1.2em;
    line-height: 0;
    flex: 0 0 auto;
    vertical-align: middle;
  }
  .resource-form-button-icon svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .resource-form-button-icon-save {
    width: 1.2em;
    height: 1.2em;
  }
  .resource-form-button-icon-save svg {
    transform: scale(1.18);
    transform-origin: center;
  }
  .copy-to-template-modal-title {
    color: #0051BA;
    font-weight: bold;
  }
  .copy-to-template-modal .modal-footer .btn {
    margin-top: 0;
  }
  .map-address-suggestions {
    max-height: 220px;
    overflow-y: auto;
    margin-top: 6px;
    margin-bottom: 0;
  }
  .map-address-search-row {
    display: flex;
    align-items: stretch;
    gap: 12px;
  }
  .map-address-search-row .form-control {
    flex: 1 1 auto;
  }
  .map-find-address-button {
    white-space: nowrap;
    min-width: 160px;
  }
  .map-location-help-banner {
    margin-top: 16px;
  }
  /* Hide DRP-dependent groups by default; JS will reveal as appropriate */
  .drp_q2_group,
  .drp_q3_portal,
  .drp_q3_agent,
  .drp_pom_choices_when_drp {
    display: none;
  }

  /* Per-field server validation error highlighting */
  .form-group.has-error {
    padding: 10px 14px;
    border-left: 4px solid #dc3545;
    background-color: rgba(220, 53, 69, 0.06);
    border-radius: 0 4px 4px 0;
  }
  .form-group.has-error > .field-label,
  .form-group.has-error label.field-label {
    color: #b21f2d;
  }
  .form-group.has-error .form-control.is-invalid,
  .form-group.has-error .custom-select.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.2);
  }
  .form-control.is-invalid,
  .custom-select.is-invalid {
    border-color: #dc3545;
  }
  .form-control.is-invalid:focus,
  .custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
  .field-error-feedback {
    margin-top: 6px;
  }
  .field-error-feedback-top {
    margin-top: 0;
    margin-bottom: 6px;
    padding: 6px 12px;
    border-left: 4px solid #dc3545;
    background-color: rgba(220, 53, 69, 0.06);
    border-radius: 0 4px 4px 0;
  }
  .field-error-feedback small {
    color: #b21f2d;
    font-size: 0.9rem;
    font-weight: 500;
    line-height: 1.3;
  }
  .field-error-feedback small + small {
    margin-top: 2px;
  }

  /* Location error banner shown near the map for lat/lng/radius errors */
  .location-error-banner {
    border-left: 4px solid #dc3545;
    background-color: rgba(220, 53, 69, 0.08);
    color: #721c24;
    padding: 10px 14px;
    border-radius: 0 4px 4px 0;
  }
  .location-error-banner ul {
    margin-bottom: 0;
  }

  /* Tab error badge: highlight a step whose fields have errors */
  .nav-tabs .nav-link.tab-has-errors h5 {
    color: #b21f2d;
  }
  .tab-error-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.25em;
    height: 1.25em;
    margin-left: 0.4em;
    font-size: 0.75em;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    background-color: #dc3545;
    border-radius: 50%;
    vertical-align: middle;
  }

  .char-counter {
    font-size: 0.875rem;
    color: #6c757d;
    white-space: nowrap;
    user-select: none;
  }
  .input-group .char-counter {
    min-width: 3.5rem;
    justify-content: center;
  }
  .form-check .char-counter {
    line-height: 2.25rem;
  }
</style>
